import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom'
import StarRatings from 'react-star-ratings';
import { useMediaQuery } from 'react-responsive'
import axios from 'axios';
import formatDate from '../../utils/dateFormatter';
import { isMobile, openInApp } from '../../utils/openInApp';
import { FormattedMessage } from 'react-intl';
import Carousel from 'react-multi-carousel';

const responsive = {
    desktop: {
        breakpoint: { max: 5000, min: 0 },
        items: 1,
        slidesToSlide: 1 // optional, default to 1.
    }
};

function ServiceProviderPage({ language }) {
    const { serviceProviderId } = useParams();
    const [serviceProvider, setServiceProvider] = useState(null);
    const [serviceProviderPortfolioItems, setServiceProviderPortfolioItems] = useState([]);
    const [startIndex, setStartIndex] = useState(0);

    const [notFound, setNotFound] = useState(false);
    const [portfolioCarouselItems, setPortfolioCarouselItems] = useState([]);

    const contactInfoDialogRef = useRef(null);
    const portfolioDialogRef = useRef(null);

    const handleOpenContactInfoDialog = () => {
        if (contactInfoDialogRef.current) {
            contactInfoDialogRef.current.showModal();
        }
    };

    const handleCloseContactInfoDialog = () => {
        if (contactInfoDialogRef.current) {
            contactInfoDialogRef.current.close();
        }
    };



    const handleOpenPortfolioDialog = () => {
        if (portfolioDialogRef.current) {
            portfolioDialogRef.current.showModal();
        }
    };

    const handleClosePortfolioDialog = () => {
        if (portfolioDialogRef.current) {
            portfolioDialogRef.current.close();
        }
    };

    const isXL = useMediaQuery({ query: '(min-width: 1824px)' });
    const isLG = useMediaQuery({ query: '(min-width: 1224px)' }) && !isXL;
    const isMD = useMediaQuery({ query: '(min-width: 768px)' }) && !isLG && !isXL;
    const isSM = useMediaQuery({ query: '(min-width: 425px)' }) && !isMD && !isLG && !isXL;
    const isXS = useMediaQuery({ query: '(max-width: 425px)' });
    const fetchServiceProviderPortfolioItems = async (stIndex) => {
        axios.get(`${process.env.REACT_APP_API_URL}user/getPortfolioItems?userId=${serviceProviderId}&startIndex=${stIndex}&limit=50`)
            .catch((err) => {
                console.log("err: " + err);
            })
            .then((response) => {
                if (response && response.data.success === true && response.data.status === 200) {
                    setServiceProviderPortfolioItems(response.data.portfolioItems);
                } else {
                    setServiceProviderPortfolioItems([]);
                }
            });
    }
    useEffect(() => {
        const fetchServiceProvider = async () => {
            axios.get(`${process.env.REACT_APP_API_URL}user/getServiceProviderProfile?userId=${serviceProviderId}&language=${language}&startIndex=0&limit=10`)
                .catch((err) => {
                    console.log("err: " + err);
                    setServiceProvider(null);
                    setNotFound(true);
                })
                .then((response) => {
                    if (response && response.data.success === true && response.data.status === 200 && response.data.user.is_deleted === 0) {
                        setServiceProvider(response.data.user);
                        document.title = response.data.user.name + " " + response.data.user.surname;
                    } else {
                        setNotFound(true);
                    }
                });
        }



        fetchServiceProvider();
        fetchServiceProviderPortfolioItems(0);

    }, [serviceProviderId, language]);

    useEffect(() => {
        fetchServiceProviderPortfolioItems(startIndex);
    }, [startIndex]);

    useEffect(() => {
        if (portfolioCarouselItems.length > 0) {
            handleOpenPortfolioDialog();
        } else {
            handleClosePortfolioDialog();
        }
    }, [portfolioCarouselItems]);

    return (
        <div>
            {serviceProvider &&
                <div style={{ display: "flex", flexDirection: "column", alignItems: "center", paddingTop: "45px", paddingBottom: "45px" }}>
                    <div style={{ display: "flex", gap: "36px" }}>
                        {(isXL || isLG || isMD) && <img src={serviceProvider.profile_photo_link} alt="service-provider-profile" style={{ borderRadius: "50%", objectFit: "cover", width: "164px", height: "164px" }} />}
                        <div style={{ width: (isXL ? "750px" : isLG ? "600px" : isMD ? "450px" : isSM ? "400px" : "290px") }}>
                            <div style={{ display: "flex", position: "relative", alignItems: "start", justifyContent: (isXS ? "center" : "space-between") }}>
                                <div style={isXS ? {} : { display: "flex", justifyContent: "center", gap: "20px" }}>
                                    {!(isXL || isLG || isMD) &&
                                        <div style={(isXL || isLG || isMD) ? {} : { textAlign: "center" }}>
                                            <img src={serviceProvider.profile_photo_link} alt="service-provider-profile" style={{ borderRadius: "50%", objectFit: "cover", width: "164px", height: "164px" }} />
                                        </div>
                                    }
                                    <div>
                                        {isXS &&
                                            <div style={{ position: "absolute", background: "#F2F0F5", padding: "2px 16px", borderRadius: "43px", border: "1px solid #8C52FF", marginBottom: "10px", right: "-10px", top: "-20px" }}>
                                                <p style={{ fontSize: "12px", margin: 0, lineHeight: "20px", color: "#8C52FF", textAlign: "center" }}>{serviceProvider.account_type === 1 ? <FormattedMessage id='corporate' /> : <FormattedMessage id='service_provider' />}</p>
                                            </div>
                                        }
                                        {!(isXL || isLG || isMD || isXS) &&
                                            <div style={{ display: "flex", justifyContent: "end" }}>
                                                <div style={{ background: "#F2F0F5", padding: "2px 16px", borderRadius: "43px", border: "1px solid #8C52FF", marginBottom: "10px" }}>
                                                    <p style={{ fontSize: "12px", margin: 0, lineHeight: "20px", color: "#8C52FF", textAlign: "center" }}>{serviceProvider.account_type === 1 ? <FormattedMessage id='corporate' /> : <FormattedMessage id='service_provider' />}</p>
                                                </div>
                                            </div>
                                        }
                                        <p style={{ fontSize: "24px", fontWeight: 800, margin: "0 0 8px 0", textAlign: isXS ? "center" : "start" }}>{serviceProvider.name} {serviceProvider.surname}{(!!serviceProvider.show_age && serviceProvider.birth_date && serviceProvider.account_type === 0) ? "," : ""} {(!!serviceProvider.show_age && serviceProvider.birth_date && serviceProvider.account_type === 0) && <span style={{ fontSize: "24px", fontWeight: 500 }}>{(new Date()).getFullYear() - (new Date(serviceProvider.birth_date)).getFullYear()}</span>}</p>
                                        <p style={{ fontSize: "16px", fontWeight: 800, margin: "0 0 8px 0", textAlign: isXS ? "center" : "start" }}>{serviceProvider.county}, {serviceProvider.city}</p>
                                        <button style={{
                                            background: "#8C52FF",
                                            padding: "10px 16px",
                                            border: "none",
                                            display: "flex",
                                            gap: "8px",
                                            alignItems: "center",
                                            borderRadius: "43px",
                                            margin: isXS ? "0 auto 0 auto" : "0px 0 0 0"
                                        }}
                                            className={'app-button'}
                                            onClick={handleOpenContactInfoDialog} >
                                            <img src="/assets/images/contact-info.png" alt="contact" height={"20px"} width={"20px"} />
                                            <p style={{ fontSize: "14px", margin: 0, color: "white", userSelect: "none" }}>
                                                <FormattedMessage id='contact_info' />
                                            </p>
                                        </button>
                                        <div style={{ display: "flex", alignItems: "center", gap: "5px", marginTop: "8px" }}>
                                            <StarRatings
                                                rating={parseFloat(serviceProvider.avarage_point.toFixed(1))}
                                                starRatedColor="#DA9207"
                                                numberOfStars={5}
                                                name='rating'
                                                starDimension='24px'
                                                starSpacing='4px'
                                            />
                                            <p style={{ fontSize: "14px", lineHeight: 0, margin: 0, color: "#DA9207", marginLeft: "5px" }}>{serviceProvider.avarage_point.toFixed(1)}</p>
                                            <p style={{ fontSize: "12px", lineHeight: 0, fontWeight: 800, margin: 0 }}>[{serviceProvider.total_review_count}]</p>
                                        </div>
                                    </div>
                                </div>
                                {(isXL || isLG || isMD) &&
                                    <div style={{ background: "#F2F0F5", padding: "2px 16px", borderRadius: "43px", border: "1px solid #8C52FF" }}>
                                        <p style={{ fontSize: "16px", margin: 0, lineHeight: "30px", color: "#8C52FF", textAlign: "center" }}>{serviceProvider.account_type === 1 ? <FormattedMessage id='corporate' /> : <FormattedMessage id='service_provider' />}</p>
                                    </div>
                                }

                            </div>
                            <div style={{ margin: "19px 0 19px 0" }}>
                                {serviceProvider.categories?.length > 0 && serviceProvider.categories.map((category, index) => {
                                    return (
                                        <div key={index}>
                                            <p style={{ fontSize: "24px", margin: "0px", fontWeight: 800 }}>
                                                {category.name}
                                            </p>
                                            <div style={{ display: "flex", alignItems: "center", overflowY: "auto", maxHeight: "200px", flexWrap: "wrap", gap: "16px", rowGap: "10px", margin: "10px 0 19px 0" }}>
                                                {category.subcategories?.length > 0 && category.subcategories.map((subcategory, index) => {
                                                    return (
                                                        <div key={index} style={{ background: "#E8E8E8", borderRadius: "4px", textAlign: "center" }}>
                                                            <p style={{ fontSize: "15px", margin: "4px 12px" }}>{subcategory.name}</p>
                                                        </div>
                                                    )
                                                }
                                                )}
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                            <p style={{ fontSize: "18px", color: "#999999", margin: "0px 0 19px 0", wordBreak: "break-word" }}>{serviceProvider.bio} </p>
                            <p style={{ fontSize: "24px", margin: "44px 0 0 0", fontWeight: 800 }}>
                                <FormattedMessage id='portfolio' />
                            </p>
                            <div style={{ margin: "19px 0 0 0" }}>
                                {serviceProviderPortfolioItems?.length > 0 &&
                                    <div style={{ display: "flex", overflowX: "auto", flexWrap: "nowrap", gap: "20px", margin: "0px 0 19px 0" }}>
                                        {serviceProviderPortfolioItems.map((portfolioItem, index) => {
                                            return <PortfolioItemBox key={index} portfolioItem={portfolioItem} width={"200px"}
                                                onClick={(e) => {
                                                    let portfolioItems = [...serviceProviderPortfolioItems];
                                                    //move the selected item to the first index and move the items before it to the end of the array
                                                    //for example [a,b,c,d] and b is selected, it will be [b,c,d,a]
                                                    portfolioItems = portfolioItems.slice(index).concat(portfolioItems.slice(0, index));
                                                    setPortfolioCarouselItems(portfolioItems);
                                                }}
                                            />
                                        })}
                                    </div>
                                }
                            </div>
                            <div>
                                <p style={{ fontSize: "24px", margin: "44px 0 0 0", fontWeight: 800 }}>
                                    <FormattedMessage id='reviews' />
                                </p>
                                <div style={{ display: "flex", gap: "30px", alignItems: "start" }}>
                                    <div style={{ display: "flex", flexDirection: "column", gap: "12px", paddingTop: "10px" }}>
                                        <RatingProgressBar width={(isXL || isLG || isMD) ? "200px" : isSM ? "90px" : isXS ? "60px" : "160px"} rating={{ relevant_point: <FormattedMessage id='quality' />, percentage: (100 * serviceProvider.avarage_service_quality_point / 5).toFixed(1), point: serviceProvider.avarage_service_quality_point }} />
                                        <RatingProgressBar width={(isXL || isLG || isMD) ? "200px" : isSM ? "90px" : isXS ? "60px" : "160px"} rating={{ relevant_point: <FormattedMessage id='timing' />, percentage: (100 * serviceProvider.avarage_timing_point / 5).toFixed(1), point: serviceProvider.avarage_timing_point }} />
                                        <RatingProgressBar width={(isXL || isLG || isMD) ? "200px" : isSM ? "90px" : isXS ? "60px" : "160px"} rating={{ relevant_point: <FormattedMessage id='communication' />, percentage: (100 * serviceProvider.avarage_communication_point / 5).toFixed(1), point: serviceProvider.avarage_communication_point }} />
                                        <RatingProgressBar width={(isXL || isLG || isMD) ? "200px" : isSM ? "90px" : isXS ? "60px" : "160px"} rating={{ relevant_point: <FormattedMessage id='pricing' />, percentage: (100 * serviceProvider.avarage_price_point / 5).toFixed(1), point: serviceProvider.avarage_price_point }} />
                                    </div>
                                    <div>
                                        <div style={{ display: "flex", alignItems: "center", gap: "5px", paddingTop: "10px" }}>
                                            <p style={{ fontSize: "25px", margin: 0 }}>{serviceProvider.avarage_point.toFixed(1)}</p>
                                            <div style={{ marginTop: "4px" }}>
                                                <StarRatings
                                                    rating={serviceProvider.avarage_point > 0 ? 1 : 0}
                                                    starRatedColor="#FFB400"
                                                    numberOfStars={1}
                                                    name='rating'
                                                    starDimension='16px'
                                                    starSpacing='0'
                                                />
                                            </div>
                                        </div>
                                        <p style={{ color: "#9E9E9E", fontSize: "12px", margin: "0", lineHeight: "166%" }}>{serviceProvider.total_review_count}<br /><FormattedMessage id={serviceProvider.total_review_count > 1 ? "review" : "review_pulural"} /></p>
                                    </div>

                                </div>
                            </div>
                            <div>
                                {serviceProvider.reviews && serviceProvider.reviews.length > 0 &&
                                    <>
                                        <p style={{ fontSize: "24px", margin: "44px 0 0 0", fontWeight: 800 }}>
                                            <FormattedMessage id='comments' />
                                        </p>
                                        <div style={{
                                            display: "flex",
                                            rowGap: "44px",
                                            columnGap: "52px",
                                            flexWrap: "wrap",
                                            marginTop: "19px",
                                        }}>
                                            {
                                                serviceProvider.reviews.map((c) =>
                                                    <CommentBox key={c.id} comment={c} width={(isXL || isLG) ? "45%" : "100%"} language={language} />
                                                )
                                            }
                                        </div>
                                    </>
                                }
                                <div style={{ display: "flex", justifyContent: "center", marginTop: "37px", color: "#999999", fontSize: "14px" }}>
                                    <FormattedMessage id='sign_up_date' />: {new Date(serviceProvider.created_date).toLocaleDateString("en-GB").replaceAll("/", ".")}
                                </div>
                                {isMobile() && (
                                    <div style={{ display: "flex", justifyContent: "center", marginTop: "37px" }}>
                                        <button
                                            onClick={() => openInApp("user", serviceProviderId)}
                                            style={{
                                                background: "#8C52FF",
                                                padding: "16px 8px",
                                                width: isSM ? "50%" : isXS ? "60%" : "35%",
                                                textAlign: "center",
                                                border: "none",
                                                cursor: "pointer"
                                            }}
                                            className={'rounded16 app-button'}
                                        >
                                            <p style={{ fontSize: "18px", margin: 0, color: "white", userSelect: "none" }}>
                                                <FormattedMessage id='see_in_app' />
                                            </p>
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {portfolioCarouselItems?.length > 0 &&
                        <dialog
                            ref={portfolioDialogRef}
                            style={{
                                border: "none",
                                borderRadius: "8px",
                                padding: "20px",
                                maxWidth: isSM || isXS ? "80%" : "60%",
                            }}
                        >
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <p style={{ fontSize: "24px", margin: "0", fontWeight: 800 }}>
                                    <FormattedMessage id='portfolio' />
                                </p>
                                <button
                                    onClick={() => {
                                        setPortfolioCarouselItems([]);
                                    }}
                                    style={{
                                        background: "transparent",
                                        border: "none",
                                        fontSize: "16px",
                                        cursor: "pointer"
                                    }}
                                >
                                    <img src="/assets/images/close-icon.png" alt="close" height={"24px"} width={"24px"} />
                                </button>
                            </div>
                            <div style={{ marginTop: "20px" }}>
                                {portfolioCarouselItems?.length > 0 &&
                                    <Carousel
                                        responsive={responsive}
                                        containerClass='portfolio-carousel-container'
                                        itemClass='portfolio-carousel-item'
                                        infinite
                                        dotListClass='react-multi-carousel-list'
                                        renderButtonGroupOutside
                                        arrows={!(isSM || isXS)}
                                    >
                                        {portfolioCarouselItems.map((item, index) =>
                                            <div key={index} style={{ textAlign: "center" }}>
                                                {item.is_photo === 1 ?
                                                    <img src={item.content_link} alt="portfolio-item"
                                                        style={{
                                                            maxWidth: "90%",
                                                            minWidth: "90%",
                                                            maxHeight: isSM || isXS ? "60vh" : "75vh",
                                                            minHeight: isSM || isXS ? "60vh" : "75vh",
                                                            objectFit: "contain",
                                                            userSelect: "none",
                                                        }} />
                                                    :
                                                    <video
                                                        style={{
                                                            maxWidth: "90%",
                                                            minWidth: "90%",
                                                            maxHeight: isSM || isXS ? "60vh" : "75vh",
                                                            minHeight: isSM || isXS ? "60vh" : "75vh",
                                                            objectFit: "contain",
                                                            userSelect: "none",
                                                        }}
                                                        alt="portfolio-item"
                                                        controls
                                                    >
                                                        <source src={item.content_link} />
                                                        <FormattedMessage id="video_error" />
                                                    </video>
                                                }
                                                <p style={{ fontSize: "16px", color: "#999999", margin: "10px 0 6px 0", lineHeight: "22px", wordWrap: "break-word" }}>
                                                    {item.description}
                                                </p>
                                            </div>)}
                                    </Carousel>
                                }
                            </div>
                        </dialog>
                    }
                    <dialog
                        ref={contactInfoDialogRef}
                        style={{
                            border: "none",
                            borderRadius: "8px",
                            padding: "20px",
                            width: isXS ? "270px" : isSM ? "280px" : "350px",
                            maxWidth: "90%"
                        }}
                    >
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <p style={{ fontSize: "24px", margin: "0", fontWeight: 800 }}>
                                <FormattedMessage id='contact_info' />
                            </p>
                            <button
                                onClick={handleCloseContactInfoDialog}
                                style={{
                                    background: "transparent",
                                    border: "none",
                                    fontSize: "16px",
                                    cursor: "pointer"
                                }}
                            >
                                <img src="/assets/images/close-icon.png" alt="close" height={"24px"} width={"24px"} />
                            </button>
                        </div>
                        <div style={{ marginTop: "20px" }}>
                            {!!serviceProvider.service_provider_phone_number &&
                                <div style={{ display: "flex", alignItems: "start", justifyContent: "space-between", gap: "20px", marginTop: "20px" }}>
                                    <div style={{ display: "flex", alignItems: "center", gap: "10px", minWidth: "30%", maxWidth: "30%" }}>
                                        <img src="/assets/images/contact-info-phone.png" alt="phone" height={"24px"} width={"24px"} />
                                        <p style={{ fontSize: "16px", margin: 0, color: "#818181", textAlign: "start" }}>
                                            <FormattedMessage id='phone' />
                                        </p>
                                    </div>
                                    <div style={{ display: "flex", alignItems: "start", gap: "9%", minWidth: "70%", maxWidth: "70%" }}>
                                        <p style={{ fontSize: "16px", margin: 0, whiteSpace: "pre-line", maxWidth: "70%", minWidth: "70%", wordBreak: "break-all" }}>
                                            {serviceProvider.service_provider_phone_number}
                                        </p>
                                        <img src="/assets/images/contact-info-arrow.png" alt="arrow" height={"24px"} width={"24px"} style={{ cursor: "pointer" }} onClick={() => {
                                            window.open(`tel:${serviceProvider.service_provider_phone_number}`, "_self")
                                        }} />
                                    </div>
                                </div>
                            }
                            {!!serviceProvider.service_provider_email &&
                                <div style={{ display: "flex", alignItems: "start", justifyContent: "space-between", gap: "20px", marginTop: "20px" }}>
                                    <div style={{ display: "flex", alignItems: "center", gap: "10px", minWidth: "30%", maxWidth: "30%" }}>
                                        <img src="/assets/images/contact-info-email.png" alt="phone" height={"24px"} width={"24px"} />
                                        <p style={{ fontSize: "16px", margin: 0, color: "#818181", textAlign: "start" }}>
                                            <FormattedMessage id='email_address' />
                                        </p>
                                    </div>
                                    <div style={{ display: "flex", alignItems: "start", gap: "9%", minWidth: "70%", maxWidth: "70%" }}>
                                        <p style={{ fontSize: "16px", margin: 0, whiteSpace: "pre-line", maxWidth: "70%", minWidth: "70%", wordBreak: "break-all" }}>
                                            {serviceProvider.service_provider_email}
                                        </p>
                                        <img src="/assets/images/contact-info-arrow.png" alt="arrow" height={"24px"} width={"24px"} style={{ cursor: "pointer" }} onClick={() => {
                                            window.open(`mailto:${serviceProvider.service_provider_email}`, "_self")
                                        }} />
                                    </div>
                                </div>
                            }
                            {!!(serviceProvider.county && serviceProvider.city && serviceProvider.country && serviceProvider.lat && serviceProvider.lng) &&
                                <div style={{ display: "flex", alignItems: "start", justifyContent: "space-between", gap: "20px", marginTop: "20px" }}>
                                    <div style={{ display: "flex", alignItems: "center", gap: "10px", minWidth: "30%", maxWidth: "30%" }}>
                                        <img src="/assets/images/contact-info-location.png" alt="phone" height={"24px"} width={"24px"} />
                                        <p style={{ fontSize: "16px", margin: 0, color: "#818181", textAlign: "start" }}>
                                            <FormattedMessage id='address' />
                                        </p>
                                    </div>
                                    <div style={{ display: "flex", alignItems: "start", gap: "9%", minWidth: "70%", maxWidth: "70%" }}>
                                        <p style={{ fontSize: "16px", margin: 0, whiteSpace: "pre-line", maxWidth: "70%", minWidth: "70%", wordBreak: "break-all" }}>
                                            {`${serviceProvider.county}, ${serviceProvider.city}, ${serviceProvider.country}`}
                                        </p>
                                        <img src="/assets/images/contact-info-arrow.png" alt="arrow" height={"24px"} width={"24px"} style={{ cursor: "pointer" }} onClick={() => {
                                            window.open(`https://www.google.com/maps/dir//${serviceProvider.lat},${serviceProvider.lng}`, "_blank")
                                        }} />
                                    </div>
                                </div>
                            }
                            {!!serviceProvider.website &&
                                <div style={{ display: "flex", alignItems: "start", justifyContent: "space-between", gap: "20px", marginTop: "20px" }}>
                                    <div style={{ display: "flex", alignItems: "center", gap: "10px", minWidth: "30%", maxWidth: "30%" }}>
                                        <img src="/assets/images/contact-info-web.png" alt="phone" height={"24px"} width={"24px"} />
                                        <p style={{ fontSize: "16px", margin: 0, color: "#818181", textAlign: "start" }}>
                                            <FormattedMessage id='website' />
                                        </p>
                                    </div>
                                    <div style={{ display: "flex", alignItems: "start", gap: "9%", minWidth: "70%", maxWidth: "70%" }}>
                                        <p style={{ fontSize: "16px", margin: 0, whiteSpace: "pre-line", maxWidth: "70%", minWidth: "70%", wordBreak: "break-all" }}>
                                            {serviceProvider.website}
                                        </p>
                                        <img src="/assets/images/contact-info-arrow.png" alt="arrow" height={"24px"} width={"24px"} style={{ cursor: "pointer" }} onClick={() => {
                                            window.open(serviceProvider.website.startsWith("http") ? serviceProvider.website : "https://" + serviceProvider.website, "_blank")
                                        }} />
                                    </div>
                                </div>
                            }
                        </div>
                    </dialog>
                </div>
            }
            {
                notFound &&
                <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "65vh" }}>
                    <h1 style={{ fontSize: "100px", fontWeight: 900, margin: 0, color: "#8C52FF" }}>404</h1>
                    <h2 style={{ fontSize: "24px", fontWeight: 900, margin: 0 }}>
                        <FormattedMessage id='user_not_found' />
                    </h2>
                </div>
            }
        </div >
    )
}


function ProgressBar({ progressStyle, fillerStyle }) {
    return (
        <div style={{ position: "relative", ...progressStyle }}>
            <div style={{
                position: "absolute",
                height: "100%",
                borderRadius: "inherit",
                transition: "width .2s ease-in",
                ...fillerStyle
            }}>
            </div>
        </div>
    )
}

function RatingProgressBar({ width, rating }) {
    return (
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <p style={{ fontSize: "14px", color: "#666666", margin: "0 0 0 0", width: "100px" }}>{rating.relevant_point}</p>
            <ProgressBar
                progressStyle={{
                    width: width,
                    height: "8px",
                    background: "#F0F0F0",
                    borderRadius: "2px",
                    marginTop: "5px",
                }}
                fillerStyle={{
                    width: (rating.percentage) + "%",
                    background: "#FFB400"
                }}
            />
            <p style={{ fontSize: "14px", color: "#666666", margin: "3px 0 0 0" }}>{rating.point.toFixed(1)}</p>
        </div>
    )
}

function CommentBox({ comment, width, language }) {

    const [showMore, setShowMore] = useState(false);
    const [canExpand, setCanExpand] = useState(false);
    const pRef = useRef(null);

    // Taşma ölçümü (sadece clamp açıkken ölç)
    const measureOverflow = () => {
        const el = pRef.current;
        if (!el) return;
        // +1 px tolerans
        const isOverflowing = el.scrollHeight > el.clientHeight + 1;
        setCanExpand(isOverflowing);
    };

    useEffect(() => {
        if (!showMore) measureOverflow();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [comment.comment, width, language, showMore === false]);

    useEffect(() => {
        const onResize = () => {
            if (!showMore) measureOverflow();
        };
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [showMore]);

    return (
        <div style={{ width }}>
            <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 12 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <img src={comment.profile_photo_link} alt={`${comment.name} ${comment.surname}`} style={{ width: 40, height: 40, borderRadius: "50%" }} />
                    <p style={{ fontSize: 20, margin: 0 }}>{`${comment.name} ${comment.surname}`}</p>
                </div>
                <div style={{ display: "flex", alignItems: "center", justifyContent: "end", gap: 5 }}>
                    <StarRatings
                        rating={1}
                        starRatedColor="#FFB400"
                        numberOfStars={1}
                        name="rating"
                        starDimension="16px"
                        starSpacing="1px"
                    />
                    <p style={{ fontSize: 16, margin: 0 }}>{comment.avarage_point.toFixed(1)}</p>
                </div>
            </div>

            <p
                ref={pRef}
                style={{
                    fontSize: 16,
                    color: "#999999",
                    margin: "0 0 6px 0",
                    wordWrap: "break-word",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: showMore ? "block" : "-webkit-box",
                    WebkitLineClamp: showMore ? "unset" : 3,
                    WebkitBoxOrient: "vertical",
                    lineHeight: "22px",
                    minHeight: "66px",
                }}
            >
                {comment.comment}
            </p>

            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                {canExpand && (
                    <button
                        type="button"
                        onClick={() => setShowMore((v) => !v)}
                        style={{
                            fontSize: 14,
                            color: "#8C52FF",
                            margin: 0,
                            cursor: "pointer",
                            padding: 0,
                            border: "none",
                            background: "transparent",
                        }}
                        aria-expanded={showMore}
                    >
                        <FormattedMessage id={showMore ? "see_less" : "see_more"} />
                    </button>
                )}
                <p style={{ fontSize: 14, color: "#999999", margin: 0, marginLeft: "auto" }}>
                    {formatDate(comment.created_date, null, false, language)}
                </p>
            </div>

            <hr />
        </div>
    );
}

function PortfolioItemBox({ portfolioItem, width, onClick }) {
    return (
        <div style={{ minWidth: width, maxWidth: width, overflow: "hidden", cursor: "pointer" }}
            onClick={onClick}
        >
            {portfolioItem.is_photo === 1 ?
                <img
                    src={portfolioItem.content_link}
                    alt={portfolioItem.description}
                    style={{ minWidth: width, maxWidth: width, minHeight: width, maxHeight: width, objectFit: "cover", borderRadius: "16px" }}
                />
                :
                <video
                    alt={portfolioItem.description}
                    style={{ minWidth: width, maxWidth: width, minHeight: width, maxHeight: width, objectFit: "cover", borderRadius: "16px" }}
                    controls

                    onClick={(e) => {
                        e.stopPropagation()
                    }}
                >
                    <source src={portfolioItem.content_link + "#t=0.2"} />
                    <FormattedMessage id="video_error" />
                </video>
            }
            <p style={{
                fontSize: "16px",
                color: "#999999",
                margin: "0 0 6px 0",
                lineHeight: "22px",
                wordWrap: "break-word",
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: 3,
                WebkitBoxOrient: "vertical",
            }}>{portfolioItem.description}</p>
        </div>
    )
}

export default ServiceProviderPage